export const uniqueKeepLast = <T, K extends keyof T>(data: T[], key: K) => {
  return [...new Map(data.map(x => [x[key], x])).values()];
};
